var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegramCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 175,
  height: 237,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#FF7E29",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.08,
  strokeWidth: 15.812,
  d: "M137.729 93.545 138 61.284l-23.125-16.017a3.394 3.394 0 0 1 1.719-6.188l109.288-7.104a5.114 5.114 0 0 1 4.799 7.55l-40.542 72.087a6.65 6.65 0 0 1-11.179.664l-17.892-24.469-17.895 9.062a3.752 3.752 0 0 1-5.444-3.324",
  clipRule: "evenodd"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 173.504,
  cy: 62.51,
  r: 103.902,
  stroke: "#FF7E29",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeOpacity: 0.08,
  strokeWidth: 15.812,
  transform: "rotate(17.374 173.504 62.51)"
})));
export default SvgTelegramCircle;